import { Dispatch } from 'redux'
import { getData } from '../utils/api'

export const RECEIVE_PREDICTED_K_INDEX = 'RECEIVE_PREDICTED_K_INDEX'
export const REQUEST_PREDICTED_K_INDEX = 'REQUEST_PREDICTED_K_INDEX'
export const ERROR_PREDICTED_K_INDEX = 'ERROR_PREDICTED_K_INDEX'
export function fetchPredictedKIndex(url: string) {
  return {
    type: REQUEST_PREDICTED_K_INDEX,
    url: url,
  }
}

export const RECEIVE_PREDICTED_3_DAY_K_INDEX = 'RECEIVE_PREDICTED_3_DAY_K_INDEX'
function receivePredicted3DayKIndex(data: any) {
  return {
    type: RECEIVE_PREDICTED_3_DAY_K_INDEX,
    data: data,
  }
}

export const REQUEST_PREDICTED_3_DAY_K_INDEX = 'REQUEST_PREDICTED_3_DAY_K_INDEX'
function requestKIndex3DayPrediction() {
  return {
    type: REQUEST_PREDICTED_3_DAY_K_INDEX,
  }
}

export const ERROR_PREDICTED_3_DAY_K_INDEX = 'ERROR_PREDICTED_3_DAY_K_INDEX'
function errorPredicted3DayKIndex(error: Error) {
  return {
    type: ERROR_PREDICTED_3_DAY_K_INDEX,
    error: error,
  }
}

export function fetchPredicted3DayKIndex(url: string) {
  return function (dispatch: Dispatch) {
    dispatch(requestKIndex3DayPrediction())
    getData(url)
      .then((data) => {
        dispatch(receivePredicted3DayKIndex(data))
      })
      .catch((e) => {
        console.error(e)
        dispatch(errorPredicted3DayKIndex(e))
      })
  }
}

export const RECEIVE_K_INDEX = 'RECEIVE_K_INDEX'
function receiveKIndex(data: any) {
  return {
    type: RECEIVE_K_INDEX,
    data: data,
  }
}

export const REQUEST_K_INDEX = 'REQUEST_K_INDEX'
function requestKIndex() {
  return {
    type: REQUEST_K_INDEX,
  }
}

export const ERROR_K_INDEX = 'ERROR_K_INDEX'
function errorKIndex(error: Error) {
  return {
    type: ERROR_K_INDEX,
    error: error,
  }
}

export function fetchKIndex(url: string) {
  return function (dispatch: Dispatch) {
    dispatch(requestKIndex())
    getData(url)
      .then((data) => {
        dispatch(receiveKIndex(data))
      })
      .catch((e) => {
        console.error(e)
        dispatch(errorKIndex(e))
      })
  }
}
